<template>
  <!-- 常见问题页面 -->
  <div class="box1">
    <!-- 搜索 -->
    <div class="search-box">
      <div class="search">
        <search :Tips="Tips" @handelScreen="handelScreen"></search>
      </div>
    </div>
    <!-- main-body 主体 -->
    <div class="main-body">
      <!-- 标题 -->
      <p class="title">知识区</p>
      <!-- 常见问题body -->
      <div class="familiar-body">
        <div class="problem-box" v-for="(item, index) in hotArr" :key="index">
          <p class="problem-title">{{ item.title }}</p>
          <div class="problem-content">
            <div class="problem-content-box">
              <ul>
                <li class="firm-clickable"
                  v-for="(item1, index1) in item.child"
                  :key="index1"
                  @click="handelDetails(item1)"
                >
                  {{ item1.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 标题 -->
      <p class="title">全部</p>
      <!-- 全部问题主体 -->
      <div class="All-body">
        <div
          class="Issue-details firm-clickable"
          v-for="(item, index) in allProblem"
          :key="index"
          @click="handelDetails(item)"
        >
          <div class="con-box">
            <div class="Issue-details-title">
              <p>{{ item.name }}</p>
              <p>阅读量：{{ item.readCount }}</p>
            </div>
            <p class="Issue-details-con">{{ item.contentText }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <paging
        :pagingObj="pagingObj"
        @handleCurrentChange="handleCurrentChange"
      ></paging>
    </div>
  </div>
</template>

<script>
import {
  postListKnowledgeArticle, // 问题列表
  postListTypeKnowledgeArticle, // 热门。常见。推荐
} from "../../../assets/api/indexl";
// 引入分页组件
import paging from "../../../components/paging.vue";
// 引入搜索组件
import search from "../../../components/search.vue";
export default {
  components: {
    // Basics
    paging,
    search,
  },
  data() {
    return {
      Tips: "请输入关键词搜索", // 传给搜索组件的数据
      input: "", // 搜索
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 6, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据

      hotArr: [
        {
          title: "热门",
          id: "1",
          child: [],
        },
        {
          title: "常见",
          id: "2",
          child: [],
        },
        {
          title: "推荐",
          id: "3",
          child: [],
        },
      ], //热门问题数据
      allProblem: [], // 全部问题数据
      contentText: "", // 问题内容
    };
  },
  created() {
    this.postListKnowledgeArticle(); //全部问题列表
    this.postListTypeKnowledgeArticle(); // 热门 推荐 常见列表数据
  },
  mounted() {},
  destroyed() {},
  methods: {
    // 热门 推荐 常见 列表
    async postListTypeKnowledgeArticle() {
      var data = {
        data: {},
      };
      const res = await postListTypeKnowledgeArticle(data);
      if (res.code == 0) {
        this.hotArr[0].child = res.data.hot;
        this.hotArr[1].child = res.data.common;
        this.hotArr[2].child = res.data.recommend;
      }
    },
    // 下方问题  全部问题列表 接口
    async postListKnowledgeArticle() {
      var data = {
        data: {
          id: this.$store.getters.getUser.id,
        },
      };
      const res = await postListKnowledgeArticle(
        data,
        this.pagingObj.currentPage, // 当前页
        this.pagingObj.pageSize
      );
      if (res.code == 0) {
        this.allProblem = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      }
    },
    // 搜索
    handelScreen(val) {
      // 打开新窗口 跳转新页面  跳转搜索详情
      let routeData = this.$router.resolve({
        path: "/results",
        query: { category: val, CurrentPage: "/knowledge" },
      });
      if (val != "") {
        window.open(routeData.href, "_blank");
      }

      // window.open("/#/results", "_blank"); //关键在此
    },
    // 跳转详情页
    handelDetails(item) {
      // 打开新窗口 跳转新页面  跳转搜索详情
      let routeData = this.$router.resolve({
        path: "/IssueDetails",
        query: { category: item.id, CurrentPage: "/knowledge" },
      });
      if (item.id != "") {
        window.open(routeData.href, "_blank");
      }
      // window.open("/#/IssueDetails", "_blank"); //关键在此
    },
    // 分页
    handleCurrentChange(num) {
      // num 要跳转的页面
      this.pagingObj.currentPage = num;
      // 下方 全部问题翻页
      this.postListKnowledgeArticle();
    },
  },
};
</script>

<style scoped lang="less">
.box1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
// 搜索
.search-box {
  width: 1184px;
  height: 54px;
  margin: auto;
  margin-bottom: 50px;
  margin-top: 33px;
  display: flex;
  .search {
    width: 720px;
    height: 54px;
    line-height: 54px;
    margin: auto;
    display: flex;
    position: relative;
  }
}
//主体
.main-body {
  width: 1184px;
  min-height: 600px;
  margin: auto;
  display: flex;
  flex-direction: column;
  // 标题
  .title {
    width: 140px;
    height: 50px;
    background-image: url("../../../assets/imgs/zhuangshi@3x.svg");
    background-size: 100% 100%;
    margin: 0 auto;
    font-family: PingFang-SC-Bold;
    font-size: 32px;
    color: #333300;
    text-align: center;
    font-weight: 600;
    margin-bottom: 30px;
  }
  // 常见问题body
  .familiar-body {
    width: 100%;
    height: 530px;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-between;
    font-family: FZLTCHK--GBK1-0;
    font-weight: 400;
    .problem-box {
      width: 370px;
      height: 100%;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
      border-radius: 20px;
      .problem-title {
        width: 370px;
        height: 60px;
        line-height: 60px;
        background-image: linear-gradient( 90deg, #F1F9FF 0%, #FFFFFF 100%);;
        border-radius: 20px 20px 0px 0px;
        font-size: 20px;
        color: #333333;
        text-align: center;
        font-weight: 600;
      }
      .problem-content {
        width: 100%;
        height: 520px;
        display: flex;
        .problem-content-box::-webkit-scrollbar {
          display: none;
        }
        .problem-content-box {
          width: 100%;
          margin: 30px;
          overflow: hidden;
          overflow-y: scroll;
          // 火狐隐藏滚动条
          scrollbar-width: none;
          li:hover {
            color: #409eff ;
          }
          li {
            height: 20px;
            line-height: 20px;
            margin-bottom: 20px;
            font-size: 16px;
            color: #333333;
            white-space: nowrap; //不换行
            overflow: hidden; //超出部分隐藏
            text-overflow: ellipsis; //文本溢出显示省略号
            cursor: pointer;
          }
        }
      }
    }
  }
  // 全部问题
  .All-body {
    width: 100%;
    min-height: 200px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #666666;
    font-weight: 400;
    .Issue-details:hover {
      box-shadow: 0px 0px 10px 0px rgba(50, 145, 248, 0.8);
    }
    .Issue-details {
      width: 100%;
      height: 80px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
      border-radius: 20px;
      margin-bottom: 20px;
      display: flex;
      cursor: pointer;
      .con-box {
        width: 100%;
        // height: 48px;
        margin: auto 0;
        margin-left: 20px;
        margin-right: 20px;
        cursor: pointer;
        .Issue-details-title {
          // height: 21px;
          width: 100%;
          display: flex;
          justify-content: flex-end;
          cursor: pointer;
          p {
            cursor: pointer;
          }
          p:nth-child(1) {
            // flex: 1;
            width: 1070px;
            font-size: 18px;
            color: #333333;
            white-space: nowrap; //不换行
            overflow: hidden; //超出部分隐藏
            text-overflow: ellipsis; //文本溢出显示省略号
            font-weight: 600;
          }
          p:nth-child(2) {
            margin-left: 20px;
            margin-right: 40px;
            width: 130px;
          }
        }
        .Issue-details-con {
          // height: 18px;
          width: 1100px;
          margin-top: 10px;
          white-space: nowrap; //不换行
          overflow: hidden; //超出部分隐藏
          text-overflow: ellipsis; //文本溢出显示省略号
          cursor: pointer;
        }
      }
    }
  }
}
// 分页
.paging {
  width: 1200px;
  height: 30px;
  margin: auto;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
